import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import * as translationAr from './i18n/ar.json';
import * as translationEn from './i18n/en.json';

const TRANSLATIONS = {
    ar: translationAr,
    en: translationEn,
};

export class TranslateUniversalLoader implements TranslateLoader {
    public getTranslation(lang: string): Observable<TranslationObject> {
        const translations = TRANSLATIONS[lang]?.default;
        if (!translations) {
            console.warn(`No translations found for language: ${lang}`);
        }
        return of(translations || {});
    }
}
